<!-- <div class="mx-auto my-6 md:my-8 px-4 sm:px-6">
  <div
    class="bonus-strip neon-container relative overflow-hidden rounded-xl flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4">

    <div class="flex items-center gap-3 sm:gap-4">

      <div class="bonus-icon">
        🎁
      </div>

      <div class="leading-tight">
        <h3 class="text-white font-semibold text-sm sm:text-base md:text-lg">
          Claim <span class="text-[#FFD54F]">Referral Bonus</span>!
        </h3>

        <div class="md:hidden">
          <p class="text-gray-300 text-[9px] sm:text-xs">
            Invite friends and <span class="text-[#FFD54F] font-semibold">Earn a {{refPercentage}}% bonus</span>
          </p>
          <p class="text-gray-300 text-[9px] sm:text-xs">
            on each of their <span class="text-[#FFD54F] font-semibold">first {{refCount}} deposits!</span>
          </p>
        </div>

        <div class="hidden md:block">
          <p class="text-gray-300 md:text-sm">
            Invite friends and <span class="text-[#FFD54F] font-semibold">Earn a {{refPercentage}}% bonus</span>on each
            of their <span class="text-[#FFD54F] font-semibold">first {{refCount}} deposits!</span>
          </p>
        </div>

      </div>
    </div>

    <button class="--button p-2" (click)="openrefral()">
      Claim Bonus
    </button>

  </div>
</div> -->


<div class="modal-overlay z-[999]" *ngIf="showRefralModal">
  <div class="modal-gradient-wrapper">
    <div class="modal-card" (click)="$event.stopPropagation()">

      <button class="close-btn" (click)="closeReferal()">✕</button>

      <h2 class="title">Referral <span class="text-accent-color">Bonus</span></h2>

      <div class="link-wrapper">
        <input type="text" [value]="referralLink" readonly />

        <button class="btn-new copy-btn-wrapper" (click)="copyToClipboard()">
          <div class="btn-new-inner">{{ buttonText }}</div>
        </button>
      </div>

      <div class="rules-box">
        <h3>Referral Bonus Rules:</h3>
        <p class="subtitle">Earn on Their First <span class="text-accent-color">{{refCount}} Deposits!</span></p>

        <div class="steps-container">
          <div class="step">
            <span class="step-number">1</span>
            <p>Refer a friend via your link.</p>
          </div>
          <div class="step">
            <span class="step-number">2</span>
            <p>Earn a <span class="text-accent-color">{{refPercentage}}%</span> bonus on each of your friend's first {{refCount}} Deposits.</p>
          </div>
        </div>
      </div>

      <button class="btn-new cta-btn-wrapper" (click)="gotoreflist()">
        <div class="btn-new-inner">View Referrals</div>
      </button>

    </div>
  </div>
</div>
